import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "search-builder"
    }}>{`Search Builder`}</h1>
    <p>{`If you are reading this we assume that you have already checked the previous section, if not please check the previous section first.`}</p>
    <p>{`So, Now you are ready to Build your Search Page Builder, The Search Builder has Two Parts`}</p>
    <ol>
      <li parentName="ol">{`Backend Section (Admin)`}</li>
      <li parentName="ol">{`Frontend Section`}</li>
    </ol>
    <h3 {...{
      "id": "backend-section-admin"
    }}>{`Backend Section (Admin):`}</h3>
    <p>{`Here, We will discuss about the Admin Options of our Plugin. We Have Divided the admin part in some sections and it's very important you know about them clearly,`}</p>
    <ul>
      <li parentName="ul">{`Reactive Builders`}</li>
      <li parentName="ul">{`Google Map`}</li>
      <li parentName="ul">{`Geobox`}</li>
      <li parentName="ul">{`Meta Restrictions`}</li>
      <li parentName="ul">{`Grid Templates`}</li>
    </ul>
    <p>{`As, We have already discussed about System Status & Reactive Menu in the previous section that's why we have only mention the Remaining Important parts of our `}<strong parentName="p">{`Reactive Plugin`}</strong>{`, that is involved with the Admin section . We will discuss about this section in details in Our next Backend Section.`}</p>
    <h3 {...{
      "id": "frontend-section"
    }}>{`Frontend Section:`}</h3>
    <p>{`After Completing the `}<inlineCode parentName="p">{`Backend setup`}</inlineCode>{`, you want to setup your Frontend Search page for the user. We have provided a `}<strong parentName="p">{`Search page Builder`}</strong>{` in the `}<inlineCode parentName="p">{`Frontend part`}</inlineCode>{` with `}<strong parentName="p">{`Drag N Drop and Resize`}</strong>{` Feature. Here, you can add & show your `}<strong parentName="p">{`Map, Grid, Search Components (ex: checkbox, radiobox etc), widget, Bar.`}</strong></p>
    <p>{`There's another `}<inlineCode parentName="p">{`Important Feature`}</inlineCode>{` added in our new `}<strong parentName="p">{`Search Page Builder`}</strong>{`, From Now on you can also Setup your `}<inlineCode parentName="p">{`Search Page`}</inlineCode>{` separately for `}<strong parentName="p">{`Mobile, Tab, Laptop, Desktop`}</strong>{`. This will `}<inlineCode parentName="p">{`Reduce lots of CSS`}</inlineCode>{` Related work for you. We will Discuss more about this in details in our Frontend Section.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      